<div class="row" *ngIf="!!token">
    <div class="col-12">
        <fenix-eess-main id="eess-tag" [id]="id" [token]="token"></fenix-eess-main>
    </div>
</div>

